import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import type { Map as MaplibreMap } from 'maplibre-gl';

interface MapContextValue {
  map: MaplibreMap | null;
  setMap: (map: MaplibreMap) => void;
}

const MapContext = createContext<MapContextValue>({ map: null, setMap: () => {} });

export const useMap = () => useContext(MapContext);

export const MapProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [map, setMapState] = useState<MaplibreMap | null>(null);
  const setMap = useCallback((m: MaplibreMap) => setMapState(m), []);
  return <MapContext.Provider value={{ map, setMap }}>{children}</MapContext.Provider>;
};
